import data from './seoPages.json';

/**
 * Titulo, descripcion y canonical de cada pagina, desde seoPages.json. El mismo
 * archivo lo lee scripts/generate-page-heads.mjs para escribirlos en el HTML
 * estatico: lo que Google ve sin JavaScript y lo que pinta SEOHead coinciden.
 */
export type SeoPageKey = keyof typeof data.pages;

export interface SeoProps {
  title: string;
  description: string;
  canonical: string;
}

export function seoPage(key: SeoPageKey): SeoProps {
  const { title, description, canonical } = data.pages[key];
  return { title, description, canonical };
}

/** /products?category=N: cada subcategoria con su titulo y su propio canonical. */
export function seoCategory(id: number, name: string): SeoProps {
  const fill = (s: string) => s.replaceAll('{name}', name).replaceAll('{id}', String(id));
  return {
    title: fill(data.category.title),
    description: fill(data.category.description),
    canonical: fill(data.category.canonical),
  };
}
